import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {TextField} from "@mui/material";


export function FieldTableTextColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'text',
            width: () => 'auto',
            className: () => '',
            // eslint-disable-next-line react/display-name
            renderViewer: (props: FieldRendererProps<any>) => {
                return props.options?.getValue ? props.options.getValue(props) : props.field.value;
//                return value;
            },
            // eslint-disable-next-line react/display-name
            renderEditor: (props: FieldRendererProps<any>) => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                const newProps = {};
                if(props.fill) {
                    newProps.sx = {
                        width:'100%',
                        height:'100%'
                    };
                }
                return (<TextField {...props.field} {...newProps} fullWidth={true} value={value} autoFocus={true} />);
//                return (<InputGroup {...props.field} value={value} autoFocus={true} />);
            },
            renderExport:(cell,props: FieldRendererProps<any>):any => {
                let value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if(value==null) value = '';
                console.log('get value',props.options?.getValue,props.field.value,value);
                cell.v = value;
                return cell;
            }
        });
    }, [context]);
    return null;
}
